import * as React from "react";
import { AnchoredPanelProps } from "./AnchoredPanelTypes";
import { InternalAnchoredPanel } from "./InternalAnchoredPanel";

export type FullPagePanelProps = Omit<AnchoredPanelProps, "preventCloseOnEsc">;

export const FullPagePanel = (props: FullPagePanelProps): JSX.Element => (
  <InternalAnchoredPanel {...props} preventCloseOnEsc />
);
